import { render, staticRenderFns } from "./PbFixed.vue?vue&type=template&id=4a247c57&"
import script from "./PbFixed.vue?vue&type=script&lang=js&"
export * from "./PbFixed.vue?vue&type=script&lang=js&"
import style0 from "./PbFixed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports